import { Component, OnInit } from '@angular/core';

import {
    selectAuthClaims,
    selectEnabledApplications
} from '../../../auth/store/auth.store';
import { RootState } from '../../../store/store.state';
import { select, Store } from '@ngrx/store';
import { ConfigManagerService } from '../../../shared/services/config-manager.service';
import { Router } from '@angular/router';
import { isArray, isString } from 'lodash-es';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import {
    Application,
    ApplicationAccessKey
} from '../../../../../common/models/application.interface';
import { GetApplicationListRequest } from '../../../utils/store/utils.action';
import { ConfigEnvironments } from '../../../../../common/models/app-config.interface';
import { LocalStorageService } from 'ngx-webstorage';
import { takeUntil } from 'rxjs/operators';
import { DropDownPopupItem } from '../../../shared/models/dropdown-popup-item.model';

@Component({
    standalone: false,
    selector: 'app-header-full',
    templateUrl: './header-full.component.html',
    styleUrls: ['./header-full.component.scss']
})
export class HeaderFullComponent implements OnInit {
    helpMenu: DropDownPopupItem<string | string[]>[];
    userMenu: DropDownPopupItem<string>[];
    userName: string;
    apps: Observable<Application[]>;
    showEnvironment: boolean;
    environment: ConfigEnvironments;
    app: string;
    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private store: Store<RootState>,
        private configManagerService: ConfigManagerService,
        private storage: LocalStorageService
    ) {
        this.environment = configManagerService.environment;
        this.showEnvironment = this.environment !== ConfigEnvironments.PROD;
        this.app = 'shopper support';
    }

    ngOnInit() {
        this.store
            .pipe(select(selectAuthClaims), takeUntil(this.destroy$))
            .subscribe((claims) => {
                this.userName = claims
                    ? `${claims.given_name} ${claims.family_name}`
                    : '';
                this.userMenu = [
                    {
                        label: claims
                            ? `${claims.given_name} ${claims.family_name}`
                            : '',
                        value: null
                    },
                    {
                        label: 'My Profile',
                        value: this.configManagerService.profileUrl
                    },
                    {
                        label: 'Sign Off',
                        value: this.configManagerService.logoutUrl
                    }
                ];
            });
        this.apps = this.store.pipe(select(selectEnabledApplications));
        this.apps
            .pipe(takeUntil(this.destroy$))
            .subscribe((appList: Application[]) => {
                this.helpMenu = [
                    // { label: 'Help Center', value: ['/support/help'] }
                ];
                appList.forEach((app) => {
                    if (app.access_key === ApplicationAccessKey.BUSINESS) {
                        this.helpMenu.push({
                            label: 'Support/Ticket',
                            value: `${app.url}/support/tickets`
                        });
                    }
                });
            });
        this.store.dispatch(new GetApplicationListRequest());
    }

    onItemClick(item: DropDownPopupItem<string | string[]>) {
        if (item.value && isArray(item.value)) {
            this.router.navigate(item.value);
        } else if (item.value && isString(item.value)) {
            // clear local storage on logout
            if (item.value === this.configManagerService.logoutUrl) {
                this.storage.clear();
            }

            window.location.href = item.value;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
